import { useState } from 'react';

const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

export function compareValues(aValue, bValue, order) {
    if (aValue == null && bValue == null) return 0;
    if (aValue == null) return 1;
    if (bValue == null) return -1;
    let result;
    if (typeof aValue === 'string' && typeof bValue === 'string') {
        result = collator.compare(aValue, bValue);
    } else if (aValue < bValue) {
        result = -1;
    } else if (aValue > bValue) {
        result = 1;
    } else {
        result = 0;
    }
    return order === 'desc' ? -result : result;
}

export function useSort(items, defaultOrderBy, defaultOrder = 'asc') {
    const [order, setOrder] = useState(defaultOrder);
    const [orderBy, setOrderBy] = useState(defaultOrderBy);

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const sortedItems = [...items].sort((a, b) => compareValues(a[orderBy], b[orderBy], order));

    return { order, orderBy, sortedItems, handleRequestSort };
}
